<template>
  <table class="table-auto w-full">
    <thead>
      <slot name="header" v-bind="{columns: columns}">
        <tr>
          <th
            v-for="column in columns"
            :key="column.slug"
            class="px-4 py-2 text-left text-xs text-sonicSilver font-light"
            :class="[...(column.headClasses || [])]"
          >
            <slot :name="`header-${column.slug}`" v-bind="column">
              {{ column.name }}
            </slot>
          </th>
        </tr>
      </slot>
    </thead>
    <tbody v-if="hasItems">
      <slot name="row" v-bind="{items: items, columns: columns}">
        <tr
          v-for="item in items"
          :key="item.id"
          class="border-t last:border-b border-gainsboro text-xs odd:bg-cultured"
          @click.stop="$emit('row-click', item)"
        >
          <td
            v-for="column in columns"
            :key="`row-${item.id}-${column.slug}`"
            :class="['px-4 py-3', ...(column.classes || [])]"
          >
            <slot :name="`column-${column.slug}`" v-bind="item">
              {{ item[column.slug] }}
            </slot>
          </td>
        </tr>
      </slot>
    </tbody>
    <tbody v-else>
      <tr
        class="row border-t last:border-b border-gainsboro text-xs odd:bg-cultured"
      >
        <td
          v-if="isLoading"
          class="px-4 py-3 text-center"
          :colspan="columnCount"
        >
          <BaseLoader size="md" />
        </td>
        <td v-else class="px-4 py-3 text-center" :colspan="columnCount">
          Нет данных
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import BaseLoader from '@/components/global/base-loader';

  export default {
    name: 'BaseTable',

    components: {
      BaseLoader,
    },

    props: {
      columns: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      hasItems() {
        return this.items.length > 0;
      },
      columnCount() {
        return this.columns.length;
      },
    },
  };
</script>
